module.exports = __webpack_public_path__ + "images/sortarr-bottom-green.svg?a927339580f3ff565c0ba5b39f445143";